import { type FC, useMemo } from 'react';
import { IconComponent } from '@/components/IconComponent';
import { TOTAL_STEPS } from '@/helpers/auth';
import { useRegModalTheme } from '@/modules/registration';
import { ScFormNavigation, ScFormNavigationItem, StatusItem } from '../styled';

const steps = Array.apply(null, Array(TOTAL_STEPS)).map((_, index) => index);

interface FormNavigationProps {
  currentStep: string;
  withMarginBottom?: boolean;
}

export const FormNavigation: FC<FormNavigationProps> = ({
  currentStep,
  withMarginBottom = true,
}) => {
  const { styleScheme } = useRegModalTheme();

  const itemsUpdated = useMemo(() => {
    const currentIndex = steps.findIndex((i) => `step${i + 1}` === currentStep);

    if (currentIndex === -1) return [];

    return [
      ...steps
        .slice(0, currentIndex)
        .map(() => ({ status: StatusItem.COMPLETED })),
      { status: StatusItem.ACTIVE },
      ...steps
        .slice(currentIndex + 1)
        .map(() => ({ status: StatusItem.NOT_ACTIVE })),
      { status: StatusItem.FINISH },
    ];
  }, [currentStep]);

  return (
    <ScFormNavigation
      styleScheme={styleScheme}
      withMarginBottom={withMarginBottom}
    >
      <ul>
        {itemsUpdated.map((item, index) => (
          <li data-status={item.status} key={index}>
            <ScFormNavigationItem {...item} styleScheme={styleScheme}>
              {item.status !== StatusItem.FINISH && (
                <span className="step">
                  {item.status === StatusItem.COMPLETED ? (
                    <IconComponent name="tickIcon" size="12px" />
                  ) : (
                    index + 1
                  )}
                </span>
              )}
            </ScFormNavigationItem>
          </li>
        ))}
      </ul>
    </ScFormNavigation>
  );
};
